(() => {
const init = () => {
 const track = document.querySelector('[id$="__seleccion"] .section-content-wrapper>.group-block>.group-block-content');
 if(track && !track.dataset.sinoReady){
  track.dataset.sinoReady="true";track.tabIndex=0;
  const title=document.querySelector('[id$="__seleccion"] h2');
  if(title){title.id=title.id||"sino-selection-title";track.setAttribute("aria-labelledby",title.id);track.setAttribute("role","region");}
  track.addEventListener("keydown",e=>{if(e.target!==track)return;const step=track.firstElementChild.getBoundingClientRect().width+28;if(e.key==="ArrowRight"||e.key==="ArrowLeft"){e.preventDefault();track.scrollBy({left:e.key==="ArrowRight"?step:-step,behavior:"smooth"});}if(e.key==="Home"||e.key==="End"){e.preventDefault();track.scrollTo({left:e.key==="End"?track.scrollWidth:0,behavior:"smooth"});}});
  let start=0,left=0,active=false,moved=false;
  track.addEventListener("pointerdown",e=>{if(e.pointerType!=="mouse"||e.button!==0)return;start=e.clientX;left=track.scrollLeft;active=true;moved=false;});
  window.addEventListener("pointermove",e=>{if(!active)return;const dx=e.clientX-start;if(Math.abs(dx)>6){moved=true;track.classList.add("sino-dragging");track.scrollLeft=left-dx;e.preventDefault();}},{passive:false});
  const stop=()=>{active=false;track.classList.remove("sino-dragging");};
  window.addEventListener("pointerup",stop);window.addEventListener("pointercancel",stop);
  track.addEventListener("click",e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  track.addEventListener("dragstart",e=>e.preventDefault());
 }
 if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches && "IntersectionObserver" in window){
  const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.add("sino-reveal");observer.unobserve(entry.target);}}},{threshold:.08});
  document.querySelectorAll("#MainContent > .shopify-section").forEach(section=>{if(section.getBoundingClientRect().top>=window.innerHeight)observer.observe(section);});
 }
};
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
document.addEventListener("shopify:section:load",init);
})();

/* Restore catalog position only on history traversal. */
(() => {
 const isCatalog=()=>location.pathname==="/pages/tienda"||location.pathname.startsWith("/collections/");
 const key=()=>"sino-catalog:"+location.pathname+location.search;
 const save=event=>{
  if(!isCatalog())return;
  const link=event?.target?.closest?.('a[href*="/products/"]');
  try{sessionStorage.setItem(key(),JSON.stringify({y:scrollY,href:link?.getAttribute("href"),offset:link?.getBoundingClientRect().top,time:Date.now()}));}catch{}
 };
 document.addEventListener("click",event=>{if(event.target.closest('a[href*="/products/"]'))save(event);},true);
 window.addEventListener("pagehide",()=>save());
 const restore=event=>{
  if(!isCatalog())return;
  const nav=performance.getEntriesByType("navigation")[0];
  if(!event.persisted&&nav?.type!=="back_forward")return;
  let saved;try{saved=JSON.parse(sessionStorage.getItem(key()));}catch{return}
  if(!saved||Date.now()-saved.time>3600000)return;
  requestAnimationFrame(()=>requestAnimationFrame(()=>window.scrollTo({top:saved.y,behavior:"instant"})));
 };
 window.addEventListener("pageshow",restore);
})();
